<template>
    <div>
        <div class="container text-center mt-5">
            <div class="card">
                <div class="d-flex justify-content-between align-items-center  pt-3 mb-3">
                    <div class="d-flex">
                        <span style="    padding: 6px 7px 10px 25px;">Empresa: </span>
                        <select class="form-control" name="" id="" v-model="empresaSelected" @change="setEmpresa()">
                            <option disabled value="">Selecione uma empresa</option>
                            <option v-for="(empresa, index) in getEmpresas" :key="index" :value="empresa">{{ empresa }}
                            </option>
                        </select>
                        <!-- <v-select :options="getEmpresas" v-model="empresaSelected" @input="setEmpresaLogin(empresaSelected)"
                            placeholder="Selecione a empresa">
                        </v-select> -->
                    </div>
                    <div>
                        <b-button v-b-toggle.collapse-1 variant="info" class="mr-2"><i
                                class="fas fa-filter mr-1"></i></b-button>

                        <button class="btn btn-success mr-3"
                            @click="exibirModalAgendamento = true, agendamentoGlobal = ''"><i class="fas fa-plus mr-1"></i>
                            Adicionar</button>
                        <button class="btn btn-outline-secondary mr-3" @click="exibirRotinas = true"><i
                                class="fa fa-cog mr-1"></i>Rotinas</button>
                    </div>
                </div>
                <b-collapse id="collapse-1">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    Filtros
                                </div>
                                <div class="card-body pt-2 pb-2 justify-content-left">
                                    <form action="" class="form">
                                        <div class="row">
                                            <div class="form-group text-left col-md-3">
                                                <label for="">Empresa</label>
                                                <select class="form-control" name="" id="" v-model="form.empresa">
                                                    <option v-for="(empresa, index) in getEmpresas" :key="index"
                                                        :value="empresa">{{ empresa }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group text-left col-md-3">
                                                <label for="">Rotina</label>
                                                <!-- <select class="form-control" name="" id="" v-model="form.rotina">
                                                    <option v-for="(rotina, index) in rotinas" :key="index"
                                                        :value="rotina">{{ rotina.ds_caminho }}
                                                    </option>
                                                </select> -->
                                                <v-select :options="rotinas" v-model="form.rotina">
                                                </v-select>
                                            </div>
                                            <div class="form-group text-left col-md-3">
                                                <label for="">Dia da Semana</label>
                                                <select class="form-control" name="" id="" v-model="form.dia">
                                                    <option v-for="(dia, index) in dias" :key="index"
                                                        :value="dia">{{ dia }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group text-left col-md-3">
                                                <label for="">Hora</label>
                                                <select class="form-control" name="" id="" v-model="form.hora">
                                                    <option v-for="(hora, index) in horas" :key="index"
                                                        :value="hora">{{ hora }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </form>
                                    <div class="col-12 d-flex justify-content-left">
                                        <button class="btn btn-info mr-2" @click="setFilter"><i class="fas fa-filter mr-1"></i>Filtrar</button>
                                        <button class="btn btn-light" @click="limparFiltro"><i class="fas fa-filter mr-1"></i>Limpar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
                <table class="table table-striped ">
                    <thead>
                        <tr>
                            <th scope="col">Empresa</th>
                            <th scope="col">Nome Rotina</th>
                            <th scope="col">Caminho</th>
                            <th scope="col">Dia</th>
                            <th scope="col">Hora</th>
                            <th scope="col">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(agendados, index) in agendamentos" :key="index">
                            <td>{{ agendados.nome_empresa }}</td>
                            <td>{{ agendados.nome_rotina }}</td>
                            <td>{{ agendados.ds_caminho }}</td>
                            <td>{{ agendados.dia_semana }}</td>
                            <td>{{ agendados.hora }}</td>
                            <th scope="row"><button class="btn btn-warning mr-2" @click="exibirModalEditar(agendados)"><i
                                        class="fa fa-pen"></i></button>
                                <button class="btn btn-danger  mr-2" @click="excluirAgendamento(agendados)"><i
                                        class="fa fa-trash"></i></button>
                                <button class="btn btn-success mr-2" @click="executarComando(agendados)"><i
                                        class="fa fa-play"></i></button>
                                <button class="btn btn-info" @click="exibirInfo(agendados)"><i
                                        class="fa fa-info-circle"></i></button>
                                <!-- <button class="btn btn-success" @click="excluirAgendamento(agendados)"></button> -->
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <pagination-painel :empresa="empresaSelected"></pagination-painel>
            </div>
            <div>
                <iframe style="border-radius: 25px;" width="800" height="400" :src="url" frameborder="0"
                    allowfullscreen></iframe>
            </div>
        </div>
        <modal-rotinas v-if="exibirRotinas" @closeModal="exibirRotinas = false"></modal-rotinas>
        <modal-agendamento v-if="exibirModalAgendamento" @closeModal="exibirModalAgendamento = false"
            :agendamento="agendamentoGlobal"></modal-agendamento>
        <modal-info-rotina v-if="exibirInfoRotina" @closeModal="exibirInfoRotina = false"></modal-info-rotina>
    </div>
</template>
<script>
import ModalRotinas from './ModalRotinas.vue'
import ModalAgendamento from './ModalAgendamento.vue'
import ModalInfoRotina from './ModalInfoRotina.vue'
import PaginationPainel from './PaginationPainel.vue'

export default {
    data() {
        return {
            exibirRotinas: false,
            exibirModalAgendamento: false,
            empresaSelected: '',
            agendamentoGlobal: '',
            url: "",
            exibirInfoRotina: false,
            form: {}
        }
    },

    components: {
        ModalRotinas,
        ModalAgendamento,
        ModalInfoRotina,
        PaginationPainel
    },
    computed: {
        getEmpresas() {
            const empresas = this.$store.getters['painel/getEmpresas']

            if (!empresas) {
                this.$store.dispatch('painel/getEmpresas')

                return []
            }

            return empresas.map(empresa => {
                return  empresa.name.toUpperCase()
            })
        },

        agendamentos() {
            return this.$store.getters['painel/getAgendamentos']
        },

        empresa() {
            return this.$store.getters['painel/getEmpresa']
        },

        rotinas() {
            const rotinas = this.$store.getters['painel/getRotinas']

            if (!rotinas) {
                this.$store.dispatch('painel/getRotinas')

                return []
            }

            return rotinas.map(rotina => {
                return {
                    ...rotina,    
                    label: rotina.ds_caminho
                }
            })
        },

        dias() {
            const dias = this.$store.getters['painel/getDias']

            return dias.map(dia => {
                return dia.dia_semana
            })
        },

        horas() {
            const arrHoras = ['HORA EM HORA']

            for (let i = 0; i <= 23; i++) {
                arrHoras.push(`${i}`)
            }

            return arrHoras
            // return arrHoras.map(hora => {
            //     return  hora
            // })
        },
        
    },
    created() {
        this.$store.dispatch('painel/getEmpresas')
        this.$store.dispatch('painel/getRotinas')
    },

    methods: {
        limparFiltro() {
            this.form = {}
            this.$store.commit('painel/setFilters', { filters: {} })
        },

        setFilter() {
            // this.$store.dispatch('painel/setFilters', { filters: this.form})
            this.$store.commit('painel/setFilters', { filters: this.form })

            this.$store.dispatch('painel/getAgendamentos', { data: '' })
        },

        exibirInfo(rotina) {
            this.exibirInfoRotina = true
            this.$store.dispatch('painel/getInfoRotina', { rotina: rotina.nr_seq_agendamento })
        },

        executarComando(comando) {
            if(this.empresaSelected == 'LOG20'){
                this.url = 'https://log20.ginfo.inovess.com.br/rotinas/' + comando.ds_caminho
            } else if(this.empresaSelected == 'COOPERCARGA') {
                this.url = 'https://coopercarga.ginfo.inovess.com.br/rotinas/' + comando.ds_caminho
            } else if(this.empresaSelected == 'PARAGUAY') {
                this.url = 'https://mercosul.ginfo.inovess.com.br/rotinas/' + comando.ds_caminho
            } else {
                this.url = 'https://ginfo.inovess.com.br/rotinas/' + comando.ds_caminho
            }
            console.log(this.empresaSelected)
            console.log(this.url)
            const data = {
                nr_seq_agendamento: comando.nr_seq_agendamento
            }
            this.$store.dispatch('painel/registrarExecucao', { data: data })
        },

        exibirModalEditar(agendamento) {
            this.exibirModalAgendamento = true
            this.agendamentoGlobal = agendamento
        },

        setEmpresa() {
            this.$store.commit('painel/setCurrentPage', { page: 1 })

            this.$store.dispatch('painel/getAgendamentos', { data: this.empresaSelected })
        },

        excluirAgendamento(agendamento) {
            console.log(agendamento)

            this.$swal.fire({
                title: 'Excluir o agendamento?',
                text: `Deseja excluir o agendamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirmar'
            }).then(result => {
                if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {
                    this.$store.dispatch('painel/deleteAgendamento', { data: agendamento }).then((response) => {
                        this.$store.dispatch('painel/getAgendamentos', { data: this.empresa.name })

                        this.$swal.fire({
                            title: 'Excluído com sucesso!',
                            text: 'O agendamento foi excluído com sucesso',
                            icon: 'success',
                            timer: 1000
                        })
                    }).catch((error) => {
                        console.log(error)
                        this.$swal.fire({
                            title: 'Ooops!',
                            text: 'Ocorreu um erro, tente novamente!',
                            icon: 'warning'
                        })
                    })
                }
            })
        }

    }
}
</script>